import { render, staticRenderFns } from "./PoistenieBanner.vue?vue&type=template&id=fad3f5c6&"
import script from "./PoistenieBanner.vue?vue&type=script&lang=js&"
export * from "./PoistenieBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VIcon,VImg,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("C:\\azagent\\_work\\3\\s\\master-v3\\Filip.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fad3f5c6')) {
      api.createRecord('fad3f5c6', component.options)
    } else {
      api.reload('fad3f5c6', component.options)
    }
    module.hot.accept("./PoistenieBanner.vue?vue&type=template&id=fad3f5c6&", function () {
      api.rerender('fad3f5c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/poistenie/PoistenieBanner.vue"
export default component.exports